<div class="screen-overlay">
  <div class="main-wrapper">
    <div class="secondary-wrapper">
      <div class="login-info-box">
        <img class="logo-image" [src]="imagesService.logo"/>
        <div class="login-box">
          <loader [show]="isLoading"></loader>
          <label class="welcome">{{ 'Screens.Login.Welcome' | translate }}</label>
          <div class="user-message"
               [ngClass]="{'error-message' : !userMessage?.isSuccess, 'success-message': userMessage?.isSuccess == true }">
            {{ userMessage?.message }}</div>
          <form (ngSubmit)="onFormSubmit()">
            <div class="email-box">
              <waf-email-input
                               name="email"
                               [label]="'Common.SearchColumnsAndDetailsFields.Email' | translate"
                               [placeholder]="'Common.SearchColumnsAndDetailsFields.Email' | translate"
                               [(ngModel)]="user.email"
                               [maxLength]="255"
                               [disabled]="step != SignInStepEnum.Email"
                               [required]="true"></waf-email-input>
            </div>

            <div #passwordBox class="animation-box"
                 [class.collapsed]="step != SignInStepEnum.Password && step != SignInStepEnum.ChangePassword">
              <waf-password-input name="password"
                                  [label]="'Screens.Login.Fields.Password' | translate"
                                  [(ngModel)]="user.password"
                                  [maxLength]="50"
                                  [disabled]="step != SignInStepEnum.Password"
                                  [hidden]="step == SignInStepEnum.ChangePassword"
                                  [autocomplete]="true"
                                  [required]="true"></waf-password-input>

              <waf-password-input name="newPassword"
                                  userPasswordValidator
                                  [doesntEqualTo]="user.password"
                                  [doesntEqualTo_validationMessage]="'Screens.Login.Messages.PasswordMustNotMatch' | translate"
                                  [equalTo]="renewPass.confirmPassword"
                                  [equalTo_fieldName]="'Screens.Login.Fields.ConfirmPassword' | translate"
                                  [label]="'Screens.Login.Fields.NewPassword' | translate"
                                  [(ngModel)]="renewPass.newPassword"
                                  [maxLength]="50"
                                  [disabled]="step != SignInStepEnum.ChangePassword"
                                  [hidden]="step != SignInStepEnum.ChangePassword"
                                  [required]="true"></waf-password-input>
            </div>

            <div #passwordConfirmBox class="animation-box"
                 [class.collapsed]="step != SignInStepEnum.ChangePassword">
              <waf-password-input #confirmPassword name="confirmPassword"
                                  [label]="'Screens.Login.Fields.ConfirmPassword' | translate"
                                  [(ngModel)]="renewPass.confirmPassword"
                                  [maxLength]="50"
                                  [disabled]="step != SignInStepEnum.ChangePassword"
                                  [required]="true"></waf-password-input>
            </div>

            <div class="login-actions">
              <button type="button" class="btn btn-default login-back-button"
                      [hidden]="step == SignInStepEnum.Email"
                      (mousedown)="backToPreviousStates()">{{'Common.SearchActionsAndDetailsActions.Back' |
                translate}}</button>

              <button type="submit" class="btn btn-success next" [hidden]="step != SignInStepEnum.Email">Next</button>

              <button type="submit" class="btn btn-success"
                      [hidden]="step != SignInStepEnum.Password">{{ 'Screens.Login.Actions.Login' | translate
                }}</button>

              <button type="submit" class="btn btn-success"
                      [hidden]="step != SignInStepEnum.ChangePassword">{{ 'Screens.Login.Actions.ChangePassword' |
                translate }}</button>
            </div>
          </form>
        </div>
      </div>
      <div class="banner-box">
        <!-- <div class="vertical-separator"></div> -->
        <div class="primary-banner">
          <img [src]="imagesService.loginPrimaryBanner"/>
        </div>
        <div class="vertical-separator"></div>
        <div class="other-banners">
          <div class="secondary-banner">
            <img [src]="imagesService.loginSecondaryBanner"/>
          </div>
          <div class="horizontal-separator"></div>
          <div class="third-banner">
            <img [src]="imagesService.loginThirdBanner" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="screen-overlay">
  <div class="main-wrapper">
    <div class="wdx-text-logo">WS Audiology Retail</div>
    <div class="brand inline totalcare-logo-wrapper">
      <img alt="logo" src="./assets/images/totalcare.png">
    </div>
    <div class="login-box">
      <loader [show]="isLoading"></loader>
      <label class="welcome">{{ 'Screens.Login.Welcome' | translate }}</label>
      <div class="user-message"
           [ngClass]="{'error-message' : !userMessage?.isSuccess, 'success-message': userMessage?.isSuccess == true }">
        {{ userMessage?.message }}</div>
      <form (ngSubmit)="onFormSubmit()">
        <div class="email-box">
          <waf-email-input
                           name="email"
                           [label]="'Common.SearchColumnsAndDetailsFields.Email' | translate"
                           [placeholder]="'Common.SearchColumnsAndDetailsFields.Email' | translate"
                           [(ngModel)]="user.email"
                           [maxLength]="255"
                           [disabled]="step != SignInStepEnum.Email"
                           [required]="true"></waf-email-input>
        </div>

        <div #passwordBox class="animation-box"
             [class.collapsed]="step != SignInStepEnum.Password && step != SignInStepEnum.ChangePassword">
          <waf-password-input name="password"
                              [label]="'Screens.Login.Fields.Password' | translate"
                              [(ngModel)]="user.password"
                              [maxLength]="50"
                              [disabled]="step != SignInStepEnum.Password"
                              [hidden]="step == SignInStepEnum.ChangePassword"
                              [autocomplete]="true"
                              [required]="true"></waf-password-input>

          <waf-password-input name="newPassword"
                              userPasswordValidator
                              [doesntEqualTo]="user.password"
                              [doesntEqualTo_validationMessage]="'Screens.Login.Messages.PasswordMustNotMatch' | translate"
                              [equalTo]="renewPass.confirmPassword"
                              [equalTo_fieldName]="'Screens.Login.Fields.ConfirmPassword' | translate"
                              [label]="'Screens.Login.Fields.NewPassword' | translate"
                              [(ngModel)]="renewPass.newPassword"
                              [maxLength]="50"
                              [disabled]="step != SignInStepEnum.ChangePassword"
                              [hidden]="step != SignInStepEnum.ChangePassword"
                              [required]="true"></waf-password-input>
        </div>

        <div #passwordConfirmBox class="animation-box"
             [class.collapsed]="step != SignInStepEnum.ChangePassword">
          <waf-password-input #confirmPassword name="confirmPassword"                              
                              [label]="'Screens.Login.Fields.ConfirmPassword' | translate"
                              [(ngModel)]="renewPass.confirmPassword"
                              [maxLength]="50"
                              [disabled]="step != SignInStepEnum.ChangePassword"
                              [required]="true"></waf-password-input>
        </div>

        <div class="login-actions">
          <button type="button" class="btn btn-default"
                  [hidden]="step == SignInStepEnum.Email"
                  (mousedown)="backToPreviousStates()">{{'Common.SearchActionsAndDetailsActions.Back' | translate}}</button>

          <button type="submit" class="btn btn-complete next" [hidden]="step != SignInStepEnum.Email">Next</button>

          <button type="submit" class="btn btn-complete"
                  [hidden]="step != SignInStepEnum.Password">{{ 'Screens.Login.Actions.Login' | translate }}</button>

          <button type="submit" class="btn btn-complete"
                  [hidden]="step != SignInStepEnum.ChangePassword">{{ 'Screens.Login.Actions.ChangePassword' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</div> -->
